$(document).ready(function() {

	$('.order-set-all-paid-butt').on( 'click', function() {

		let subscriptions_ar = [];

		document.querySelectorAll('.order-summary-table > tbody > tr').forEach( $tr => {
			
			if ( typeof $tr.dataset.id_subscription != "undefined")
				subscriptions_ar.push($tr.dataset.id_subscription);

			swal({
				title: set_all_paid_dialog.dialog_text,
				buttons: {
					cancel: {
						text: set_all_paid_dialog.cancel_butt,
						value: false,
						visible: true,
						className: "",
						closeModal: true
					},
					setallpaid: {
						text: set_all_paid_dialog.confirm_butt,
						value: true,
						visible: true,
						className: "",
						closeModal: true
					}
				},
				icon: "warning"
			}).then(function(isConfirm) {
				if (isConfirm != null)

					$.post(
						APP_ROOT +
							"/api/" +
							LOCALE +
							"/v1/race-manager/subscription/set-payment-status",
						{
							paid: 1,
							id_subscription_ar: subscriptions_ar
						},
						function(response) {
							swal({
								title: set_all_paid_dialog.confirm_text,
								icon: "success"
							})
						},
						"json"
					);

			});

		})

	})

})
